import { render } from "./DemoLeadForm.vue?vue&type=template&id=45fbb97b&scoped=true"
import script from "./DemoLeadForm.vue?vue&type=script&lang=js"
export * from "./DemoLeadForm.vue?vue&type=script&lang=js"

import "./DemoLeadForm.vue?vue&type=style&index=0&id=45fbb97b&scoped=true&lang=css"
import "./DemoLeadForm.vue?vue&type=style&index=1&id=45fbb97b&lang=css"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fbb97b"]])

export default __exports__